var isPersistedChatMessageAdminApi = function (message) { return Boolean(message.createdAt); };
export default isPersistedChatMessageAdminApi;
